const configuration = {
  apiUrl: process.env.REACT_APP_API_URL,
  loginUrl: process.env.REACT_APP_LOGIN_URL,
  loginRedirectUri: process.env.REACT_APP_LOGIN_REDIRECT_URL,
  publicWebsiteUrl: process.env.REACT_APP_PARATENNIS_PUBLIC_URL,
  releaseNumber: process.env.REACT_APP_RELEASE_NUMBER,
  maxPageSize: 10000000,
}

export default configuration
